<template>
  <el-tabs type="card" v-model="current">
    <el-tab-pane label="货品管理" name="goods">
      <div class="search-container">
        <el-form ref="form" inline>
          <el-form-item label="名称" label-width="80px">
            <el-input v-model="queryParam.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="类型" label-width="80px">
            <el-radio v-model="queryParam.type">全部</el-radio>
            <el-radio v-model="queryParam.type" :label="0">油品</el-radio>
            <el-radio v-model="queryParam.type" :label="1">物料</el-radio>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" @click="list(1)">
              <el-icon><search /></el-icon>查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-container">
        <div class="table-header">
          <el-row :gutter="10">
            <el-col :span="10">
              <div class="table-title"><span></span>货品列表</div>
            </el-col>
            <el-col :span="14">
              <div class="table-button-container">
                <el-button type="success" @click="showGoods()">
                  <el-icon><plus /></el-icon>新增货品
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table :data="goodsList" border>
          <el-table-column type="index" label="序号"></el-table-column>
          <!--
          <el-table-column label="图片">
            <template #default="scope">
              <img :src="$utils.imageSrc(scope.row.pic)" v-if="scope.row.pic" />
            </template>
          </el-table-column>
          -->
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="pack" label="规格"></el-table-column>
          <el-table-column label="类型">
            <template #default="scope">
              {{scope.row.type === 0 ? '油品' : '物料'}}
            </template>
          </el-table-column>
          <el-table-column label="单位">
            <template #default="scope">
              <div>{{scope.row.baseRelation}}{{scope.row.baseUnit}}</div>
              <div v-if="scope.row.firstRelation">= {{scope.row.firstRelation}}{{scope.row.firstUnit}}</div>
              <div v-if="scope.row.secondRelation">= {{scope.row.secondRelation}}{{scope.row.secondUnit}}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否上架">
            <template #default="scope">
              {{scope.row.sale === 0 ? '否' : '是'}}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-link type="primary" href="javascript:;" @click="showGoods(scope.row)">修改</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                       :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                       background
                       layout="sizes, prev, pager, next, total"></el-pagination>
      </div>

      <el-dialog :title="goods.sn ? '修改货品' : '新增货品'" v-model="saveGoodsVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="goods" ref="goods">
          <el-form-item label="图片" label-width="78px">
            <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/goods'" :show-file-list="false"
                       :on-success="handleSuccess" :before-upload="beforeUpload">
              <img v-if="goods.pic" :src="$utils.imageSrc(goods.pic)">
              <el-icon v-else class="uploader_icon"><plus /></el-icon>
            </el-upload>
            <div class="tips"><i>建议尺寸：500 * 500</i></div>
          </el-form-item>
          <el-form-item label="名称" label-width="78px">
            <el-input type="text" v-model="goods.name"></el-input>
          </el-form-item>
          <el-form-item label="规格" label-width="78px">
            <el-input type="text" v-model="goods.pack"></el-input>
          </el-form-item>
          <el-form-item label="类型" label-width="78px">
            <el-radio v-model="goods.type" :label="0">油品</el-radio>
            <el-radio v-model="goods.type" :label="1">物料</el-radio>
          </el-form-item>
          <el-form-item label="单位" label-width="78px">
            <el-row :gutter="8">
              <el-col :span="14">
                <el-input type="text" v-model="goods.baseRelation"></el-input>
              </el-col>
              <el-col :span="10">
                <el-select v-model="goods.baseUnit">
                  <el-option v-for="item in paramUnits" :key="item.sn" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="单位1" label-width="78px">
            <el-row :gutter="8">
              <el-col :span="14">
                <el-input type="text" v-model="goods.firstRelation"></el-input>
              </el-col>
              <el-col :span="10">
                <el-select v-model="goods.firstUnit">
                  <el-option v-for="item in paramUnits" :key="item.sn" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="单位2" label-width="78px">
            <el-row :gutter="8">
              <el-col :span="14">
                <el-input type="text" v-model="goods.secondRelation"></el-input>
              </el-col>
              <el-col :span="10">
                <el-select v-model="goods.secondUnit">
                  <el-option v-for="item in paramUnits" :key="item.sn" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="是否上架" label-width="78px">
            <el-radio v-model="goods.sale" :label="0">否</el-radio>
            <el-radio v-model="goods.sale" :label="1">是</el-radio>
          </el-form-item>
          <el-button type="primary" @click="saveGoods">确定</el-button>
        </el-form>
      </el-dialog>
    </el-tab-pane>
    <el-tab-pane label="单位管理" name="unit">
      <div class="table-container">
        <div class="table-header">
          <el-row :gutter="10">
            <el-col :span="10">
              <div class="table-title"><span></span>单位列表</div>
            </el-col>
            <el-col :span="14">
              <div class="table-button-container">
                <el-button type="success" @click="showUnit()">
                  <el-icon><plus /></el-icon>新增单位
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table :data="units" border>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="name" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-link type="primary" href="javascript:;" @click="showUnit(scope.row)">修改</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:current-page="unitPageIndex" @size-change="handleSizeChange"
                       :page-size="unitPageSize" :total="unitTotal" :page-sizes="pageSizes" :pager-count="5"
                       background
                       layout="sizes, prev, pager, next, total"></el-pagination>
      </div>

      <el-dialog :title="unit.sn ? '修改单位' : '新增单位'" v-model="saveUnitVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="unit" ref="unit">
          <el-form-item label="单位名称" label-width="78px">
            <el-input type="text" v-model="unit.name"></el-input>
          </el-form-item>
          <el-button type="primary" @click="saveUnit">确定</el-button>
        </el-form>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "货品管理",
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      current: 'goods',
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      goodsList: [],
      saveGoodsVisible: false,
      goods: {},
      unitPageIndex: 1,
      unitPageSize: 10,
      unitTotal: 0,
      units: [],
      saveUnitVisible: false,
      unit: {},
      paramUnits: []
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSuccess(res, file) {
      this.goods.pic = res.data
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.storeGoods.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.goodsList = response.data.data
        this.total = response.data.total
      })
    },
    showGoods(goods) {
      this.saveGoodsVisible = true
      if (!goods) {
        this.goods = {
          type: 0,
          sale: 0
        }
      } else {
        Object.assign(this.goods, goods)
      }
      this.$apis.storeGoods.unitList(0, 99).then(response => {
        this.paramUnits = response.data.data
      })
    },
    saveGoods() {
      if (!this.goods.name) {
        this.$message.error('请输入名称')
        return
      }
      if (!this.goods.pack) {
        this.$message.error('请输入规格')
        return
      }
      if (!this.goods.baseRelation || !this.goods.baseUnit) {
        this.$message.error('请输入单位')
        return
      }
      if (!this.goods.sn) {
        this.$apis.storeGoods.add(this.goods).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveGoodsVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.storeGoods.edit(this.goods).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveGoodsVisible = false
            this.list()
          }
        })
      }
    },
    unitList(pageIndex) {
      if (pageIndex) {
        this.unitPageIndex = pageIndex
      }
      this.$apis.storeGoods.unitList(this.unitPageIndex - 1, this.unitPageSize).then(response => {
        this.units = response.data.data
        this.unitTotal = response.data.total
      })
    },
    showUnit(unit) {
      this.saveUnitVisible = true
      if (!unit) {
        this.unit = {}
      } else {
        Object.assign(this.unit, unit)
      }
    },
    saveUnit() {
      if (!this.unit.name) {
        this.$message.error('请输入单位名称')
        return
      }
      if (!this.unit.sn) {
        this.$apis.storeGoods.addUnit(this.unit).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveUnitVisible = false
            this.unitList()
          }
        })
      } else {
        this.$apis.storeGoods.editUnit(this.unit).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveUnitVisible = false
            this.unitList()
          }
        })
      }
    },
    handleCurrentChange(pageIndex) {
      if (this.current === 'unit') {
        this.unitPageIndex = pageIndex
        this.unitList()
      } else {
        this.pageIndex = pageIndex
        this.list()
      }
    },
    handleSizeChange(pageSize) {
      if (this.current === 'unit') {
        this.unitPageSize = pageSize
        this.unitList(1)
      } else {
        this.pageSize = pageSize
        this.list(1)
      }
    }
  },
  created() {
    this.list(1)
    this.unitList(1)
  }
}
</script>

<style scoped>

</style>